module.exports = __webpack_public_path__ + "img/12. Karishma Pradhan.1b17dbfc.jpg";